// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wN9z","col":"styles_col__30y9s"};